
export class DateHelper {

    static AddDays(date: Date, count: number): Date {
        var date_ = new Date(date);
        date_.setDate(date_.getDate() + count);
        return date_;
    }

    static AddHours(date: Date, count: number): Date {
        var date_ = new Date(date);
        date_.setTime(date_.getTime() + (count * 60 * 60 * 1000));
        return date_;
    }

    static AddMinutes(date: Date, count: number): Date {
        var date_ = new Date(date);
        date_.setTime(date_.getTime() + (count * 60 * 1000));
        return date_;
    }
} 